import React, { useState, useEffect } from 'react';
import { Typography, Link, Breadcrumbs } from '@mui/material';
import { useLocation } from "react-router-dom";

const HeaderBreadCrumb = (props) => {
    let location = useLocation();
    const [value, setValue] = useState([]);

    useEffect(() => {
        var pathArray = location.pathname.split('/').slice(1);
        var v = []
        pathArray.map((p, i) => {

            switch (p) {
                case 'edit':
                case 'details':
                case 'create':
                    v.push({
                        name: pathArray[i - 1].charAt(0).toUpperCase() + pathArray[i - 1].slice(1).toLowerCase(),
                        link: location.pathname.split(`/${pathArray[i - 1]}`)[0] + '/' + pathArray[i - 1] + '/list/'
                    })
                    v.push({
                        name: pathArray[i].charAt(0).toUpperCase() + pathArray[i].slice(1).toLowerCase(),
                        link: ""
                    })
                    break;
                case 'list':


                    v.push({
                        name: pathArray[i - 1].charAt(0).toUpperCase() + pathArray[i - 1].slice(1).toLowerCase(),
                        link: location.pathname.split(`/${pathArray[i - 1]}`)[0]
                    })
                    v.push({
                        name: p,
                        link: ''
                    })
                    break;
                default:
                    break;
            }
        });
        setValue(v)
    }, [location])

    // useEffect(()=>{
    //     if(blockDetails?.name){
    //         var v = [...value];
    //         var i = v.findIndex(v=>v.replace==='blocks');
    //         v[i].name = blockDetails?.name;
    //         setValue(v);
    //     }
    //     if(fieldDetails?.name){
    //         var v = [...value];
    //         var i = v.findIndex(v=>v.replace==='fields');
    //         v[i].name = fieldDetails?.label;
    //         setValue(v);
    //     }

    // }, [blockDetails, fieldDetails])

    return (
        <Breadcrumbs separator={'>'}>
            <Typography align="left"><Link href={'/'} underline="hover">Home</Link></Typography>
            {value.map((v, i) =>
                <Typography key={i} align="left">

                    {v.link !== '' ?
                        <Link href={v.link} underline='hover'>
                            {v.name}
                        </Link>
                        :
                        <React.Fragment>
                            {v.name}
                        </React.Fragment>
                    }



                </Typography>

            )}
        </Breadcrumbs>

    )
}


export default HeaderBreadCrumb;
